import { useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import ContactInformationCell from '@/modules/templates/components/ContactInformationCell';

export const useFieldsContactInformation = (isViewMode, form, question, runAudit, audit, currentAudit) => {
  const {t} = useTranslation('templates');
  return useMemo(() => {
    const fieldsMap = [];
    if(currentAudit?.id) {
      const initValues = currentAudit?.contactFields?.find(x => x?._id === question?._id)?.value;
      if (!isViewMode) {
        fieldsMap?.splice(
          0, 0,
          {
            key: 'contactInformationFields',
            onlyEdit: true,
            colSpan: 24,
            initialValue: initValues,
            widget: ({...props}) => <ContactInformationCell
              form={form}
              initialValues={initValues}
              t={t}
              questionId={question?._id}
              runAudit={runAudit}
              audit={audit}
              {...props}/>,
          }
        );
      }
    }
    return fieldsMap;
  }, [currentAudit, isViewMode, form, t, question?._id, runAudit, audit]);
};

